// routes
import { PATH_AUTH } from '../routes/paths';
import API from '../services/API';
// utils

// ----------------------------------------------------------------------

function jwtDecode(token) {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(
    window
      .atob(base64)
      .split('')
      .map((c) => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`)
      .join('')
  );

  return JSON.parse(jsonPayload);
}

// ----------------------------------------------------------------------

export const isValidToken = (accessToken) => {
  if (!accessToken) {
    return false;
  }

  const decoded = jwtDecode(accessToken);

  const currentTime = Date.now() / 1000;

  return decoded.exp > currentTime;
};

// ----------------------------------------------------------------------

export const tokenExpired = (exp) => {
  // eslint-disable-next-line prefer-const
  let expiredTimer;

  const currentTime = Date.now();
  const timeLeft = exp * 1000 - currentTime;

  clearTimeout(expiredTimer);

  expiredTimer = setTimeout(() => {
    alert('Token expired');
    sessionStorage.removeItem('accessToken');
    sessionStorage.removeItem('wb_auth_active');
    window.location.href = PATH_AUTH.login;
  }, timeLeft);
};

// ----------------------------------------------------------------------

/**
 * WB-PP-01/02: do NOT persist JWT. Auth is httpOnly cookie via /api/proxy BFF.
 */
export const setSession = (accessToken) => {
  sessionStorage.removeItem('accessToken');
  delete API.defaults.headers.common.Authorization;

  if (accessToken) {
    sessionStorage.setItem('wb_auth_active', '1');
  } else {
    sessionStorage.removeItem('wb_auth_active');
  }
};

export const setCsrfSession = (csrfToken) => {
  if (csrfToken) {
    API.defaults.headers.common['x-csrf-token'] = csrfToken;
  } else {
    delete API.defaults.headers.common['x-csrf-token'];
  }
};

/** Clear httpOnly cookie via BFF (call on logout). */
export const clearServerSession = async () => {
  try {
    await fetch('/api/auth/session', {
      method: 'DELETE',
      credentials: 'include',
    });
  } catch (_) {
    /* ignore */
  }
};
